// Link to Career Coaches tab. Placed below the Q&A on the Cover Letter page.

import { ArrowRight, Award } from "lucide-react";

interface Props {
  onNavigate?: () => void;
}

export default function ResumePartnerLink({ onNavigate }: Props) {
  return (
    <div className="rounded-xl border border-emerald-200 dark:border-emerald-800 bg-emerald-50 dark:bg-emerald-900/20 p-4 mt-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-emerald-100 dark:bg-emerald-800/40 flex items-center justify-center shrink-0">
          <Award className="w-5 h-5 text-emerald-600 dark:text-emerald-400" />
        </div>
        <div className="flex-1">
          <h4 className="font-display font-semibold text-sm text-foreground">
            Want a coach in your corner?
          </h4>
          <p className="text-xs text-muted-foreground mt-0.5">
            Browse vetted career coaches for interview prep, strategy, and more.
          </p>
        </div>
        <button
          type="button"
          onClick={onNavigate}
          className="flex items-center gap-1 text-xs font-semibold text-emerald-600 dark:text-emerald-400 hover:text-emerald-700 dark:hover:text-emerald-300 transition-colors shrink-0"
        >
          Career Coaches
          <ArrowRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
